import React, { useState, useEffect } from "react";
import "./FoodMenuCard.css";
import QRCode from 'qrcode';
import { FaBeer, FaWineGlassAlt, FaGlassWhiskey } from "react-icons/fa";
import { MdIosShare } from "react-icons/md";



const categories = [
  {
    name: "Veg Soups",
    // subtitle: "",
    themeColor: "#ffffff",
    headerColor: "#FB8C00",
    items: [
      { id: 1, name: "Veg Manchow Soup", price: 120, type: "veg", description: "[500ml] A hot and sour soup with mixed vegetables, soy sauce, and crispy noodles... read more" },
      { id: 2, name: "Cream Of Tomato Soup", price: 110, type: "veg", description: "[500ml] A smooth, creamy soup made with ripe tomatoes, cream, and a hint of spices... read more" },
      { id: 3, name: "Veg Sweet Corn Soup", price: 130, type: "veg", description: "[500ml] A smooth soup made with sweet corn, vegetable stock, and a hint of spices... read more" },
      { id: 4, name: "Veg Clear Soup", price: 100, type: "veg", description: "[500ml] A simple, clear soup made with vegetable stock, herbs, and light seasoning." },
      { id: 5, name: "Veg Hot & Sour Soup", price: 125, type: "veg", description: "[500ml] A flavorful soup with mixed vegetables, chili, and vinegar for a spicy-sour taste... read more" },
      { id: 6, name: "Veg Talumein Soup", price: 130, type: "veg", description: "[500ml] A light soup with mixed vegetables, noodles, and a clear, flavorful broth." },
      { id: 7, name: "Cream Of Dal Soup", price: 140, type: "veg", description: "[500ml] A thick soup made with lentils, cream, and spices, offering a hearty flavor... read more" },
      { id: 8, name: "Veg Lemon Grass Soup", price: 135, type: "veg", description: "[500ml] A fragrant soup made with lemongrass, mixed vegetables, and a hint of spices... read more" },
      { id: 9, name: "Veg Oriental Soup", price: 145, type: "veg", description: "[500ml] A soup with mixed vegetables, soy sauce, and Oriental spices for a tasty flavor... read more" },
    ],
  },
  {
    name: "Chicken Soups",
    subtitle: "Hot and tasty chicken soups",
    themeColor: "#ffffff",
    headerColor: "#D32F2F",
    items: [
      { id: 10, name: "Chicken Manchow Soup", price: 150, type: "nonveg", description:"[500ml] A soup with mixed vegetables, soy sauce, and Oriental spices for a tasty flavor... read more" },
      { id: 11, name: "Chicken Sweet Corn Soup", price: 160, type: "nonveg", description: "[500ml] A smooth soup made with sweet corn, chicken stock, and a hint of spices... read more" },
      { id: 12, name: "Chicken Clear Soup", price: 140, type: "nonveg", description:"[500ml] A simple, clear soup made with chicken stock, herbs, and light seasoning." },
      { id: 13, name: "Cream Of Chicken Soup", price: 170, type: "nonveg", description: "[500ml] A rich soup made with chicken stock, cream, and aromatic spices." },
      { id: 14, name: "Chicken Hot And Sour Soup", price: 175, type: "nonveg", description: "[500ml] A flavorful soup with mixed vegetables, chili, and vinegar for a spicy-sour taste... read more" },
      { id: 15, name: "Chicken Rainbow Soup", price: 180, type: "nonveg", description: "[500ml] A colorful soup made with mixed vegetables and chicken broth... read more" },
      { id: 16, name: "Chicken Tom Yum Soup", price: 185, type: "nonveg", description: "[500ml] A spicy and sour soup made with chicken, mushrooms, and Thai herbs." },
    ],
  },
  {
    name: "Seafood Soups",
    subtitle: "",
    themeColor: "#ffffff",
    headerColor: "#00838F",
    items: [
      { id: 17, name: "Seafood Soup", price: 200, type: "nonveg", description: "[500ml] A flavorful soup made with a mix of fish, prawns, and other seafood... read more" },
    ],
  },
  {
    name: "Mutton Soups",
    subtitle: "Rich and hearty mutton soups",
   themeColor: "#ffffff",
    headerColor: "#6A1B9A",
    items: [
      { id: 18, name: "Cream Of Mutton Soup", price: 220, type: "nonveg", description: "[500ml] A hearty soup made with mutton stock, cream, and aromatic spices." },
      { id: 19, name: "Mutton Tabak Maaz Soup (6 Pieces)", price: 250, type: "nonveg", description: "A rich soup made with mutton ribs, spices, and herbs, served with 6 pieces... read more" },
      { id: 20, name: "Mutton Aab Gosht Soup (3 Pieces)", price: 240, type: "nonveg", description: "A flavorful mutton soup cooked with aromatic spices and herbs, served with 3 pieces... read more" },
    ],
  },
  {
    name: "Veg Chinese Starters",
    subtitle: "Delicious vegetarian starters",
    themeColor: "#ffffff",
    headerColor: "#2E7D32",
    items: [
      { id: 21, name: "Paneer Dragon Dry", price: 250, type: "veg", description: "[12 Pieces] Paneer cooked with a blend of spices and chili... read more" },
      { id: 22, name: "Paneer Teriyaki Dry", price: 260, type: "veg", description: "[12 Pieces] Paneer cooked in a sweet and savory teriyaki sauce... read more" },
      { id: 23, name: "Veg Manchurian Dry", price: 230, type: "veg", description: "[12 Pieces] Vegetable balls cooked with soy sauce, chili, and garlic... read more" },
      { id: 24, name: "Veg Spring Roll", price: 200, type: "veg", description: "Rolls filled with mixed vegetables, wrapped and deep-fried for a crispy texture." },
    ],
  },
  {
    name: "Chicken Chinese Starters",
    subtitle: "Tasty chicken starters",
   themeColor: "#ffffff",
    headerColor: "#D32F2F",
    items: [
      { id: 25, name: "Chicken Lollipop (6 Pieces)", price: 300, type: "nonveg", description: "Chicken drumettes marinated in spices, shaped into lollipops, and deep-fried." },
      { id: 26, name: "Chicken Chilly Dry", price: 320, type: "nonveg", description: "[12 Pieces] Chicken cooked with green chilies, soy sauce, and vinegar... read more" },
      { id: 27, name: "Chicken Crispy", price: 310, type: "nonveg", description: "Chicken pieces coated in a crispy batter and deep-fried for a crunchy texture." },
    ],
  },
  {
    name: "Indian Starters & Kebabs",
    subtitle: "Veg & Non-Veg kebabs",
   themeColor: "#ffffff",
    headerColor: "#FBC02D",
    items: [
      { id: 28, name: "Paneer Tikka Kebab (6 Pieces)", price: 280, type: "veg", description: "Paneer cubes marinated in yogurt and spices, grilled to perfection." },
      { id: 29, name: "Chicken Tandoori", price: 350, type: "nonveg", description: "Chicken marinated in yogurt, spices, and tandoori masala, cooked in a clay oven." },
      { id: 30, name: "Mutton Seekh Kebab (6 Pieces)", price: 380, type: "nonveg", description: "Minced mutton mixed with spices, shaped into skewers, and grilled." },
      { id: 31, name: "Fish Jalandari Tikka (6 Pieces)", price: 400, type: "nonveg", description: "Fish pieces marinated in Punjabi spices and grilled for a bold, spicy flavor." },
    ],
  },
  {
    name: "Bar & Drinks",
    subtitle: "Whisky • Beer • Wine • Vodka",
    themeColor: "#ffffff",
    headerColor: "#5D4037",
    items: [
      { id: 201, name: "Royal Stag Whisky (30ml)", price: 120, type: "bar", symbol: "🥃" },
      { id: 202, name: "Blenders Pride (30ml)", price: 180, type: "bar", symbol: "🥃" },
      { id: 203, name: "Red Label Whisky (30ml)", price: 220, type: "bar", symbol: "🥃" },
     
      { id: 206, name: "Smirnoff Vodka (30ml)", price: 190, type: "bar", symbol: "🥃" },
      { id: 207, name: "Old Monk Rum (30ml)", price: 160, type: "bar", symbol: "🥃" },
      { id: 208, name: "Red Wine Glass", price: 250, type: "bar", symbol: "🍷" },
    ],
  },
];

// The main component
export default function FoodMenuCard() {
  const [drinkOnly, setDrinkOnly] = useState(false);
 const [openNoteId, setOpenNoteId] = useState(null);
 const [showViewCart, setShowViewCart] = useState(true);
 const [isModifying, setIsModifying] = useState(false);

 const [showWaiterConfirm, setShowWaiterConfirm] = useState(false);
const [waiterCalled, setWaiterCalled] = useState(false);

  const [noteText, setNoteText] = React.useState("");
  const [itemNotes, setItemNotes] = useState({});
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const [search, setSearch] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [cart, setCart] = useState({});
  const [showCongrats, setShowCongrats] = useState(false);
  const [vegOnly, setVegOnly] = useState(false);
  const [favOnly, setFavOnly] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [showPayment, setShowPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [qrUrl, setQrUrl] = useState("");
  const [expandedItems, setExpandedItems] = useState({});
  // const [wineOnly, setWineOnly] = useState(false);
  // const [expandedInstructions, setExpandedInstructions] = useState({});
  const [openRatingId, setOpenRatingId] = useState(null);
  const [showFloatingSubmit, setShowFloatingSubmit] = useState(false);
  const [floatingPosition, setFloatingPosition] = useState({ top: 0, left: 0 });
  const [submitItemId, setSubmitItemId] = useState(null);






  const handleShare = (item) => {
  const text = `${item.name}
${item.type === "veg" ? "🟢 Veg" : item.type === "bar" ? "🍷 Wine" : "🔴 Non-Veg"}
Price: ₹${item.price}

${item.description || ""}`;

  if (navigator.share) {
    navigator.share({
      title: item.name,
      text: text,
    });
  } else {
    navigator.clipboard.writeText(text);
    alert("Item copied! Paste & share anywhere.");
  }
};

const scrollToCart = () => {
  const cartEl = document.getElementById("cart-section");
  if (cartEl) {
    cartEl.scrollIntoView({ behavior: "smooth" });
  }
};
  
const handleViewCartClick = () => {
  setShowViewCart(false); // 👈 button hide
  const cartEl = document.getElementById("cart-section");
  if (cartEl) {
    cartEl.scrollIntoView({ behavior: "smooth" });
  }
};

const toggleReadMore = (id) => {
  setExpandedItems((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
};

  const addItem = (item, e) => {
  setCart((prev) => ({
    ...prev,
    [item.id]: prev[item.id]
      ? { ...item, qty: prev[item.id].qty + 1 }
      : { ...item, qty: 1 },
  }));

  setShowViewCart(true); // ⭐ IMPORTANT

  if (e) {
    const rect = e.target.getBoundingClientRect();
    setFloatingPosition({ top: rect.top - 60, left: rect.left });
    setShowFloatingSubmit(true);
  }
};



  const removeItem = (item) => {
    setCart((prev) => {
      if (!prev[item.id]) return prev;
      const qty = prev[item.id].qty - 1;
      if (qty <= 0) {
        const updated = { ...prev };
        delete updated[item.id];
        return updated;
      }
      return { ...prev, [item.id]: { ...item, qty } };
    });
  };

  const startVoiceSearch = () => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Voice search not supported in this browser");
      return;
    }
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-IN";
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.onstart = () => setIsListening(true);
    recognition.onresult = (event) => setSearch(event.results[0][0].transcript);
    recognition.onerror = () => setIsListening(false);
    recognition.onend = () => setIsListening(false);
    recognition.start();
  };

  const totalAmount = Object.values(cart).reduce(
    (sum, item) => sum + item.price * item.qty,
    0
  );

  useEffect(() => {
    if (paymentMethod === "upi") {
      const upiString = `upi://pay?pa=8707805222@hdfcbank&pn=Foodie Paradise&am=${totalAmount}&cu=INR`;
      QRCode.toDataURL(upiString)
        .then(url => setQrUrl(url))
        .catch(err => console.error(err));
    }
  }, [paymentMethod, totalAmount]);

  const submitOrder = () => {
    if (!Object.keys(cart).length) {
      alert("Please add some items first!");
      return;
    }
    setShowPayment(true);
  };
// const clearCart = () => {
//   setCart({});
//   setShowViewCart(false); 
// };

  const handlePaymentSuccess = () => {
    setShowPayment(false);
    setShowCongrats(true);
    setCart({});
    setTimeout(() => setShowCongrats(false), 3000);
  };

 const applyFilter = (item) => {
  switch (activeFilter) {
    case "Under Rs200":
      return item.price <= 200;

    case "Pure Veg Gourmet":
      return item.type === "veg";

    case "Highly Reordered":
      return item.reorderCount >= 100; // ⭐ MAIN LOGIC

    case "Rating 4.0+":
      return true;

    case "Great Offer":
      return item.price < 250;

    default:
      return true;
  }
};

const VegNonVegSymbol = ({ type }) => {
  const isVeg = type === "veg";
  if (type === "bar") {
    return (
      <span
        style={{
          width: 24,
          height: 24,
          borderRadius: 6,
          background: "#5D4037",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 8,
          fontSize: 14,
        }}
      >
        🍺
      </span>
    );
  }

  return (
    <span
      style={{
        width: 16,
        height: 16,
        border: `2.5px solid ${isVeg ? "#1FA463" : "#E23744"}`,
        borderRadius: 2,
        backgroundColor: "#FFFFFF",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 6,
        boxSizing: "border-box",
        flexShrink: 0,
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "100%",
          backgroundColor: isVeg ? "#1FA463" : "#E23744",
        }}
      />
    </span>
  );
};
  return (
  <div
  className={`menu-root ${darkMode ? "dark-theme" : "light-theme"}`}
  style={{ textAlign: "center", paddingBottom: 110 }}
>

      {/* HEADER */}
<div
  className="sticky-header"
  style={{
    position: "sticky",
    top: 0,
    zIndex: 100,
    padding: "10px 12px", // ⬅️ thoda compact
    textAlign: "center",

    background: darkMode
      ? "linear-gradient(135deg, #1b5e20, #0d3b1e)"
      : "linear-gradient(135deg, #c62828, #2e7d32)",

    borderBottom: "3px solid #FFD700",
  }}
>
  <h1
  style={{
    fontSize: 36,
    fontWeight: 900,
    letterSpacing: "2px",
    fontFamily: "'Cinzel', serif",
    color: "#FFD700",
    textAlign: "center",
    textShadow: "0 2px 8px rgba(255,215,0,0.8)",
    margin: 0,
    lineHeight: 1,
  }}
>
  THE TRIBE
</h1>

  {/* SUB TITLE + BUTTON (NICHE HI RAHEGA) */}
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 10,
      marginTop: 4,
    }}
  >
    <p
      style={{
        fontSize: 11,
        letterSpacing: "1.2px",
        textTransform: "uppercase",
        color: "#FFF8E1",
        margin: 0,
        fontWeight: 600,
      }}
    >
      Restaurant & Bar
    </p>
    <button
      onClick={() => setDarkMode(!darkMode)}
      style={{
        padding: "3px 9px",
        borderRadius: 14,
        border: "1px solid #FFD700",
        background: darkMode ? "#1b5e20" : "#b71c1c",
        color: "#FFD700",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: 11,
      }}
    >
      {darkMode ? "🌙" : "☀️"}
    </button>
  </div>
    {/* SEARCH + VERTICAL BUTTONS RIGHT SIDE */}
<div style={{ display: "flex", gap: 10 }}>
  <div style={{ position: "relative", flex: 1 }}>
    <input
      type="text"
      placeholder="Search food..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{
        width: "67%",              // ❗ SAME AS YOUR ORIGINAL
        padding: "12px 60px 12px 12px", // only right padding for icons
        borderRadius: 10,           // SAME
        border: "1px solid var(--form-bd)",  // SAME
      }}
    />
    {/* CLEAR ❌ (SAME PLACE) */}
    {search && (
      <span
        onClick={() => setSearch("")}
        style={{
          position: "absolute",
          right: 48,
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          fontWeight: "bold",
          color: "#FF5722",
          fontSize: 16,
        }}
      >
        ❌
      </span>
    )}

    {/* MIC ICON – ONLY ADDITION */}
    <span
      onClick={startVoiceSearch}
      style={{
        position: "absolute",
        right: 14,
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 35,
        height: 30,
        borderRadius: "50%",
        border: "1px solid var(--border-color)",
        background: "var(--light-grey)",
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={isListening ? "green" : darkMode ? "#fff" : "#555"}
      >
        <path d="M12 14a3 3 0 003-3V5a3 3 0 00-6 0v6a3 3 0 003 3zm5-3a1 1 0 112 0 7 7 0 01-6 6.92V21h-2v-3.08A7 7 0 015 11a1 1 0 112 0 5 5 0 0010 0z" />
      </svg>
    </span>
  </div>
 {/* HORIZONTAL TOGGLES */}
<div
  style={{
    display: "flex",
    flexDirection: "row",
    gap: 6,
    alignItems: "center",
  }}
>
  {/* VEG TOGGLE */}
  <div
    onClick={() => setVegOnly(!vegOnly)}
    style={{
      width: 45,        // ab width lambi
      height: 27,       // height chhoti
      borderRadius: 16,
      background: vegOnly ? "var(--content-color)" : "var(--form-bd)",
      cursor: "pointer",
      position: "relative",
      padding: 2,
      transition: "background 0.3s",
    }}
  >
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: "#ffffff",
        position: "absolute",
        top: 2,
        left: vegOnly ? "calc(100% - 24px)" : 2, // 👉 LEFT → RIGHT
        transition: "left 0.3s",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      }}
    >
      {vegOnly ? (
        <div
          style={{
            width: 12,
            height: 12,
            border: "2px solid #0B7A0B",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#0B7A0B",
            }}
          />
        </div>
      ) : (
        <span style={{ fontSize: 9, color: "#686767ff" }}>OFF</span>
      )}
    </div>
  </div>

 {/* DRINK TOGGLE */}
<div
  onClick={() => setDrinkOnly(!drinkOnly)}
  style={{
    width: 45,
    height: 27,
    borderRadius: 16,
    background: drinkOnly ? "#5D4037" : "var(--form-bd)",
    cursor: "pointer",
    position: "relative",
    padding: 2,
    transition: "background 0.3s",
  }}
>
  <div
    style={{
      width: 22,
      height: 22,
      borderRadius: "50%",
      background: "#ffffff",
      position: "absolute",
      top: 2,
      left: drinkOnly ? "calc(100% - 24px)" : 2,
      transition: "left 0.3s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 12,
    }}
  >
    {drinkOnly ? "🍺" : "🍽️"}
  </div>
</div>
</div>
</div>

      </div>
     <div style={{ display: "flex", gap: 10, overflowX: "auto", padding: "10px 0" }}>
  {/* Favorites Toggle */}
  <button
    onClick={() => setFavOnly(!favOnly)}
    style={{
      flex: "0 0 auto",
      padding: "8px 12px",
      borderRadius: 20,
      border: "1px solid var(--form-bd)",
      background: favOnly ? "#FFCDD2" : "var(--content-color)",
      color: favOnly ? "#000" : "var(--text-color)",
      cursor: "pointer",
      fontWeight: "bold",
      whiteSpace: "nowrap",
    }}
  >
    Favorites
  </button>

  {/* Filter Buttons */}
  {["Pure Veg Gourmet", "Rating 4.0+", "Great Offer"].map((filter) => (
    <button
      key={filter}
      onClick={() => setActiveFilter(activeFilter === filter ? "" : filter)}
      style={{
        flex: "0 0 auto",
        padding: "8px 12px",
        borderRadius: 20,
        border: "1px solid var(--form-bd)",
        background: activeFilter === filter ? "#FFE082" : "var(--content-color)",
        color: activeFilter === filter ? "#000" : "var(--text-color)",
        cursor: "pointer",
        fontWeight: "bold",
        whiteSpace: "nowrap",
      }}
    >
      {filter}
    </button>
  ))}
  {/* Sort Button */}
  <button
    onClick={() => setSortBy(sortBy === "reorder" ? "" : "reorder")}
    style={{
      flex: "0 0 auto",
      padding: "8px 12px",
      borderRadius: 20,
      border: "1px solid var(--form-bd)",
      background: sortBy === "reorder" ? "#FFE082" : "var(--content-color)",
      color: sortBy === "reorder" ? "#000" : "var(--text-color)",
      cursor: "pointer",
      fontWeight: "bold",
      whiteSpace: "nowrap",
    }}
  >
    Highly Reordered
  </button>
</div>
   {/* CATEGORIES */}
{categories.map((cat) => {
 let filteredItems = cat.items.filter((item) =>
  item.name.toLowerCase().includes(search.toLowerCase())
);

// 🔹 CASE 1: BOTH OFF → SHOW ALL
if (!vegOnly && !drinkOnly) {
  // koi extra filter nahi
}

// 🔹 CASE 2: VEG ONLY
else if (vegOnly && !drinkOnly) {
  filteredItems = filteredItems.filter(item => item.type === "veg");
}

// 🔹 CASE 3: DRINK ON (Veg + Wine)
else if (drinkOnly) {
  filteredItems = filteredItems.filter(
    item => item.type === "veg" || item.type === "bar"
  );
}

// 🔹 EXTRA FILTERS (always apply AFTER main toggle logic)
if (activeFilter) {
  filteredItems = filteredItems.filter(applyFilter);
}

if (sortBy === "reorder") {
  filteredItems = [...filteredItems].sort((a, b) => b.price - a.price);
}


  if (filteredItems.length === 0) return null;

  return (
    <div
      key={cat.name}
      className="menu-card"
      style={{
        background: darkMode ? "var(--bg-color)" : cat.themeColor,
        borderRadius: 10,
        padding: 15,
        marginBottom: 15
      }}
    >
      <h3 style={{ color: "var(--text-color)", fontWeight: "bold" }}>
        {cat.icon} {cat.name}
      </h3>
      <p className="menu-muted" style={{ fontSize: 12 }}>
        {cat.subtitle}
      </p>
      <div>
        {filteredItems.map((item) => (
        <div
          key={item.id}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto auto",
            alignItems: "center",
           padding: "6px 0",

            borderBottom: "1px solid var(--border-color)",
            columnGap: 16
          }}
        >
          
          <div>
           <strong style={{ display: "flex", alignItems: "center" }}>
{item.type === "bar" ? (
  <span style={{ marginRight: 6, fontSize: 16 }}>
    {item.symbol === "beer" && <FaBeer color="#F1C40F" />}
    {item.symbol === "wine" && <FaWineGlassAlt color="#800020" />}
    {item.symbol === "whisky" && <FaGlassWhiskey color="#8B4513" />}
    {!["beer","wine","whisky"].includes(item.symbol) && "🍺"}
  </span>
) : (
  <VegNonVegSymbol type={item.type} />
)}

  {item.name}
  <span style={{ color: "var(--text-lighter)" }}> ₹.{item.price}</span>

</strong>




{/* ⭐ RATING BUTTON */}
<div style={{ position: "relative", marginTop: 2 }}>
  <button
    onClick={() =>
      setOpenRatingId(openRatingId === item.id ? null : item.id)
    }
    style={{
      background: "#0f9d58",
      color: "#fff",
      border: "none",
      borderRadius: 12,
      padding: "2px 6px",
      fontSize: 11,
      fontWeight: "bold",
      cursor: "pointer",
      lineHeight: "14px",
    }}
  >
    ⭐ 4.0+
  </button>

  {/* 🔽 SMALL POPUP */}
  {openRatingId === item.id && (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        marginTop: 4,
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: 6,
        padding: "6px 8px",
        fontSize: 11,
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        zIndex: 10,
        width: 140,
      }}
    >
      Based on customer reviews
    </div>
  )}
</div>

{/* DESCRIPTION (only if exists) */}
{item.description && expandedItems[item.id] && (
  <div
    style={{
      fontSize: 12,
      color: "var(--text-lighter)",
      marginTop: 4,
      lineHeight: 1.3,
    }}
  >
    {item.description}
  </div>
)}
{/* SHARE + READ MORE (ALWAYS SHOW SHARE) */}
<div
  onClick={() => handleShare(item)}
  style={{
    width: 20,
    height: 20,
    border: "1.5px solid #2ef22bff",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "transparent",
  }}
>
  <MdIosShare size={15} />
</div>
<div style={{ marginTop: -10 }}>
  
  {/* READ MORE – ONLY IF DESCRIPTION EXISTS */}
  {item.description && (
    <span
      onClick={() => toggleReadMore(item.id)}
      style={{
        color: "#fa1b1bff",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 12,
        marginTop: 4,     // ⬅️ yaha space add kiya
      display: "inline-block", // ⬅️ marginTop kaam kare
      }}
    >
      {expandedItems[item.id] ? "read less" : "read more"}
    </span>
  )}
</div>
          </div>
          
  <div
  style={{
    display: "flex",
    alignItems: "flex-start",
    marginTop: -45,
    gap: 8,
  }}
>
  {/* ⬅️ LEFT : Qty + Instruction */}
 <div style={{ position: "relative" }}>
  {/* ➕➖ Quantity Box (FIXED SIZE) */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: 80, // FIXED WIDTH
      border: "0.5px solid var(--border-color)",
      borderRadius: 6,
      padding: "2px",
      background: "#fff",
    }}
  >
    
    <button
      onClick={() => removeItem(item)}
      style={{
        width: 26,
        height: 26,
        fontSize: 14,
        fontWeight: "bold",
        background: "#fe7b2fff",
        color: "#fbf7f7ff",
        border: "none",
        borderRadius: 5,
        cursor: "pointer",
        lineHeight: "26px",
        padding: 0,
      }}
    >
      −
    </button>

    <span
      style={{
        width: 28, // FIXED WIDTH
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
        overflow: "hidden",
      }}
    >
      {cart[item.id]?.qty || 0}
    </span>
<button
  onClick={(e) => {
    addItem(item, e);
    setSubmitItemId(item.id);
  }}
  style={{
    width: 26,
    height: 26,
    fontSize: 14,
    fontWeight: "bold",
    background: "#fa6f24ff",
    color: "#f8f7f7ff",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    lineHeight: "26px",
    padding: 0,
  }}
>
  +
</button>


{/* 🛒 SIMPLE VIEW CART BUTTON */}
{/* 🛒 SIMPLE VIEW CART BUTTON – RIGHT SIDE */}
{showViewCart && Object.keys(cart).length > 0 && (
  <div
    onClick={handleViewCartClick}
    style={{
      position: "fixed",
      top: "50%",
      right: 12,                     // ✅ RIGHT SIDE
      transform: "translateY(-50%)", // ✅ only vertical center
      background: "#ff2238",
      color: "#fff",
      padding: "6px 12px",
      borderRadius: 6,
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
      zIndex: 9999,
      boxShadow: "0 2px 6px rgba(251, 227, 227, 0.3)",
    }}
  >
    View Cart ({Object.keys(cart).length})
  </div>
)}
</div>
{/* 🔔 HALDIRAM STYLE CALL WAITER BUTTON */}
<div
  onClick={() => {
    if (waiterCalled) return;
    setShowWaiterConfirm(true);
  }}
  style={{
    position: "fixed",
    right: 14,
    bottom: 90,              // View Cart ke niche
    background: "#ffffff",
    color: "#000",
    padding: "8px 14px",
    borderRadius: 14,
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    zIndex: 9999,
    border: "1px solid #ddd",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    opacity: waiterCalled ? 0.6 : 1,
  }}
>
  🔔 {waiterCalled ? "Waiter on the way" : "Call Waiter"}
</div>

  {/* 🔘 ONE BUTTON ONLY (TEXT + MIC INSIDE, SMALLER) */}
{/* NOTE BUTTON – sirf qty > 0 par */}
{cart[item.id]?.qty > 0 && (
  <div style={{ marginTop: 4 }}>

    {/* 📝🎤 BUTTON */}
    <button
      onClick={() => setOpenNoteId(item.id)}
      style={{
        width: "75%",
        height: 22,
        background: "#f543d4ff",
        color: "#fff",
        border: "none",
        borderRadius: 5,
        fontSize: 12,
        cursor: "pointer",
      }}
    >
      📝 🎤
    </button>

    {/* 🔲 POPUP */}
    {openNoteId === item.id && (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(250, 247, 227, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999,
        }}
        onClick={() => setOpenNoteId(null)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "#fff",
            padding: 8,
            borderRadius: 6,
            width: 240,
          }}
        >
          <div style={{ display: "flex", gap: 6 }}>
            <input
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              placeholder="Type instruction"
              style={{
                flex: 1,
                fontSize: 12,
                padding: "4px 6px",
              }}
            />

            {/* 🎤 MIC */}
            <span
              onClick={() => {
                const SR =
                  window.SpeechRecognition ||
                  window.webkitSpeechRecognition;
                const rec = new SR();
                rec.lang = "en-IN";
                rec.onresult = (e) =>
                  setNoteText(e.results[0][0].transcript);
                rec.start();
              }}
              style={{ cursor: "pointer" }}
            >
              🎤
            </span>
          </div>

          {/* ✅ SUBMIT – sirf jab text ho */}
          {noteText.trim() && (
            <button
              onClick={() => {
                setItemNotes({
                  ...itemNotes,
                  [item.id]: noteText,
                });
                setNoteText("");
                setOpenNoteId(null);
              }}
              style={{
                marginTop: 6,
                width: "100%",
                background: "#fa6f24ff",
                color: "#fff",
                border: "none",
                borderRadius: 4,
                fontSize: 12,
                cursor: "pointer",
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    )}

    {/* 🔴 READ MORE / LESS */}
    {itemNotes[item.id] && (
      <div
        onClick={() =>
          setExpandedNoteId(
            expandedNoteId === item.id ? null : item.id
          )
        }
        style={{
          marginTop: 2,
          fontSize: 12,
          color: "red",
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        {expandedNoteId === item.id ? "read less" : "read more"}
      </div>
    )}
    

    {/* 📄 NOTE TEXT */}
    {expandedNoteId === item.id && (
      <div
        style={{
          fontSize: 12,
          background: "#fff3f3",
          padding: 4,
          borderRadius: 4,
          marginTop: 2,
        }}
      >
        {itemNotes[item.id]}
      </div>
    )}
  </div>
)}
</div>

  {/* ➡️ RIGHT : Price (NO CHANGE) */}
  <div
    style={{
      minWidth: 60,
      textAlign: "right",
      fontWeight: "bold",
      paddingTop: 4,
    }}
  >
    
    ₹{cart[item.id] ? cart[item.id].qty * item.price : 0}
  </div>
</div>
        </div>
        ))}
      </div>
    </div>
    
  );
})}

      {/* CART */}
      <div
  id="cart-section"
  style={{
    marginTop: 30,
    padding: 15,
    border: "1px solid var(--border-color)",
    borderRadius: 8,
    background: "var(--content-color)",
    textAlign: "center",
  }}
>

        <h3 style={{ color: "var(--text-color)", fontWeight: "bold", margin: 0 }}>Cart</h3>
        {Object.keys(cart).length > 0 ? (
          <>
            <table style={{ width: "100%", borderCollapse: "collapse", margin: "10px 0", color: "var(--text-color)" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--border-color)" }}>
                  <th style={{ padding: "8px", textAlign: "left" }}>Item</th>
                  <th style={{ padding: "8px", textAlign: "center" }}>Qty</th>
                  <th style={{ padding: "8px", textAlign: "right" }}>Price</th>
                  <th style={{ padding: "8px", textAlign: "right" }}>Total</th>
                </tr>
              </thead>
            <tbody>
  {Object.values(cart).map((item) => (
    <tr key={item.id} style={{ borderBottom: "1px solid var(--border-color)" }}>
      <td style={{ padding: "8px", textAlign: "left" }}>{item.name}</td>

      {/* Quantity cell */}
      <td style={{ padding: "8px", textAlign: "center" }}>
        {isModifying ? (
          <div style={{ display: "flex", gap: 4, justifyContent: "center", alignItems: "center" }}>
            <button
              onClick={() => removeItem(item)}
              style={{ padding: "2px 6px", borderRadius: 4, cursor: "pointer" }}
            >
              −
            </button>
            <span>{item.qty}</span>
            <button
              onClick={() => addItem(item)}
              style={{ padding: "2px 6px", borderRadius: 4, cursor: "pointer" }}
            >
              +
            </button>
          </div>
        ) : (
          <span>{item.qty}</span>
        )}
      </td>

      <td style={{ padding: "8px", textAlign: "right" }}>₹{item.price}</td>
      <td style={{ padding: "8px", textAlign: "right" }}>₹{item.price * item.qty}</td>
    </tr>
  ))}
</tbody>

            </table>
            <h4 style={{ color: "var(--text-color)", fontWeight: "bold", margin: "10px 0" }}>Total: ₹{totalAmount}</h4>
          <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 10 }}>
  <button
    onClick={() => setIsModifying(!isModifying)}
    style={{
      padding: "12px 24px",
      backgroundColor: "#ff9800",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: 16,
    }}
  >
    {isModifying ? "Done" : "Modify Cart"}
  </button>

  <button
    onClick={submitOrder}
    style={{
      padding: "12px 24px",
      backgroundColor: "#22ff6c",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: 16,
    }}
  >
    Submit Order
  </button>
</div>



              {/* <button onClick={submitOrder} style={{ padding: "12px 24px", backgroundColor: "#22ff6cff", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold", fontSize: 16 }}>
                Submit Order
              </button>
           */}
          </>
        ) : (
          <div style={{ marginTop: 10 }}>
            <p style={{ color: "var(--text-lighter)", margin: "20px 0" }}>Your cart is empty</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button onClick={submitOrder} style={{ padding: "12px 24px", backgroundColor: "#FF5722", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold", fontSize: 16 }}>
                Submit Order
              </button>
            </div>
          </div>
        )}
      </div>

      {/* PAYMENT MODAL */}
      {showPayment && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 999 }}>
          <div style={{ background: "var(--content-color)", padding: 30, borderRadius: 12, textAlign: "center", boxShadow: "0 4px 20px rgba(0,0,0,0.3)", maxWidth: 400, width: "90%" }}>
            <h2 style={{ color: "var(--text-color)", marginBottom: 20 }}>Payment Options</h2>
            <p style={{ color: "var(--text-lighter)", marginBottom: 20 }}>Total Amount: ₹{totalAmount}</p>
            
            {!paymentMethod && (
              <div>
                <button
                  onClick={() => setPaymentMethod("upi")}
                  style={{ margin: 10, padding: "10px 20px", backgroundColor: "#26ff22ff", color: "#0e1101ff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}
                >
                  Pay with UPI
                </button>
                <button
                  onClick={() => setPaymentMethod("card")}
                  style={{ margin: 10, padding: "10px 20px", backgroundColor: "#31ff22ff", color: "#0b0000ff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}
                >
                  Pay with Credit Card
                </button>
              </div>
            )}

            {paymentMethod === "upi" && (
              <div>
                <p style={{ color: "var(--text-lighter)", marginBottom: 20 }}>Scan the QR code to pay</p>
                <img src={qrUrl} alt="UPI QR Code" style={{ width: 200, height: 200, margin: "0 auto", display: "block" }} />
                <button
                  onClick={handlePaymentSuccess}
                  style={{ marginTop: 20, padding: "10px 20px", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}
                >
                  Payment Successful
                </button>
              </div>
            )}

            {paymentMethod === "card" && (
              <div>
                <input type="text" placeholder="Card Number" style={{ width: "100%", padding: 10, marginBottom: 10, border: "1px solid var(--form-bd)", borderRadius: 4, background: "var(--bg-color)", color: "var(--text-color)" }} />
                <input type="text" placeholder="Expiry Date" style={{ width: "48%", padding: 10, marginRight: "4%", border: "1px solid var(--form-bd)", borderRadius: 4, background: "var(--bg-color)", color: "var(--text-color)" }} />
                <input type="text" placeholder="CVV" style={{ width: "48%", padding: 10, border: "1px solid var(--form-bd)", borderRadius: 4, background: "var(--bg-color)", color: "var(--text-color)" }} />
                <button
                  onClick={handlePaymentSuccess}
                  style={{ marginTop: 20, padding: "10px 20px", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold", width: "100%" }}
                >
                  Pay Now
                </button>
              </div>
            )}

            <button
              onClick={() => { setShowPayment(false); setPaymentMethod(""); }}
              style={{ marginTop: 20, padding: "10px 20px", backgroundColor: "#ccc", color: "#000", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
{/* 🛎️ CALL WAITER CONFIRM POPUP */}
{showWaiterConfirm && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.35)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: 20,
        borderRadius: 16,
        width: 280,
        textAlign: "center",
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
      }}
    >
      <div style={{ fontSize: 16, fontWeight: 700 }}>
        Call Waiter?
      </div>

      <p style={{ fontSize: 13, color: "#555", marginTop: 6 }}>
        Our staff will assist you shortly.
      </p>

      <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
        <button
          onClick={() => setShowWaiterConfirm(false)}
          style={{
            flex: 1,
            padding: "8px",
            borderRadius: 10,
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
          onClick={() => {
            setWaiterCalled(true);
            setShowWaiterConfirm(false);
            alert("Waiter has been notified 🧑‍🍳");
          }}
          style={{
            flex: 1,
            padding: "8px",
            borderRadius: 10,
            border: "none",
            background: "#000",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Call
        </button>
      </div>
    </div>
  </div>
)}

      {/* CONGRATS POPUP */}
      {showCongrats && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 999 }}>
          <div style={{ background: "var(--content-color)", padding: 30, borderRadius: 12, textAlign: "center", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}>
                       <h2 style={{ fontSize: 24, marginBottom: 15, color: "#FF5722" }}>🎉 Order Placed!</h2>
            <p style={{ fontSize: 16, color: "var(--text-lighter)" }}>Thank you for your order. Your food will be delivered soon!</p>
            <button
              onClick={() => setShowCongrats(false)}
              style={{ marginTop: 20, padding: "10px 20px", backgroundColor: "#FF5722", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}
            >
              Close
            </button>
          </div>
        </div>
      )}
      </div>
   
  );
}

